if (!customElements.get('navarambh-hero')) {
  customElements.define('navarambh-hero', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        const hero = this.querySelector('.nvHero');
        if (!hero) return;
        this.classList.add('is-ready');
        void hero.offsetHeight;
        this.frame = requestAnimationFrame(() => hero.classList.add('is-in'));
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
    }
  });
}
